<<template>
  <section>
    <el-row type="flex" class="row-bg" justify="space-around" style="margin-bottom: 30px;">
      <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>今日订单数</div>
            <div>{{orderCount}}</div>
          </div>
        </div>
      </el-col>
          <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>待填单号</div>
            <div>{{danhaoCount}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>今日订单金额</div>
            <div>{{orderSum}}</div>
          </div>
        </div>
      </el-col>
          <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>今日订单利润|率</div>
            <div>{{profitSum}}|{{numFilter(profitSum/orderSum*100)}}</div>
          </div>
        </div>
      </el-col>
        <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>当月订单数量</div>
            <div>{{orderCountMonth}}</div>
          </div>
        </div>
      </el-col>
            <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>当月总金额|共创</div>
            <div>{{orderSumMonth}}|{{numFilter(orderSumGongChuangMonth/orderSumMonth*100)}}</div>
          </div>
        </div>
      </el-col>
          <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>当月订单利润|率</div>
            <div>{{profitSumMonth}}|{{numFilter(profitSumMonth/orderSumMonth*100)}}</div>
          </div>
        </div>
      </el-col>
                 <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>当月共创产出|总</div>
            <div>{{profitSumGongChuangMonth}}|{{orderSumGongChuangMonth}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
            <div>新增|地址客户</div>
            <div>{{userCount}}|{{userZongCount}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="grid-content bg-purple">
          <div>
          <div>库存低|总商品</div>
            <div>{{kucunCount}}|{{proCount}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="12">
        <div id="order"></div>
      </el-col>
      <el-col :span="12">
        <div id="orderSum"></div>
      </el-col>
    </el-row>
	 <el-row type="flex" class="row-bg">
      <el-col :span="12">
        <div id="gongChuangOrder"></div>
      </el-col>
      <el-col :span="12">
        <div id="gongChuangOrderSum"></div>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="12">
        <div id="user"></div>
      </el-col>
      <el-col :span="12">
        <div id="profitSum"></div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
    // 导入echarts
    import echarts from 'echarts'
    import $ from 'jquery'
    import config from '../config'
    import {formatDate} from '../static/js/date.js'

    export default {
        data() {
            return {
              orderCount: 0,
              orderSum: 0,
              userCount: 0,
              kucunCount: 0,
              profitSum:0,
              proCount:0,
              userZongCount:0,
              profitSumMonth:0,
              profitSumGongChuangMonth:0,
              orderSumGongChuangMonth:0,
               danhaoCount: 0,
              orderEchart: null,
              orderSumEchart: null,
			  orderGongChuangEchart: null,
              orderGongChuangSumEchart: null,
              userEchart: null,
              loginEchart: null,
              time: '',
              startTime: '',
              endTime: '',
              orderCountMonth:0,
               orderProfitEchart: null,
              orderSumMonth: 0
            }
        },
        methods: {
          //获取订单数量
          getOrderCount() {
            this.$axios.get(config.api_url + '/order/count/'+this.time
            ).then(response => {
              this.orderCount = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单数量异常，请联系管理员',
                type: 'error'
              });
            });
          },
          //获取订单趋势
          getOrderEchart() {
            this.$axios.get(config.api_url + '/order/echart/'+this.startTime+'/'+this.endTime
            ).then(response => {
              let data = response.data.msg,
                timeArr = [],
                dataArr = [];
              for(const item of data) {
                timeArr.push(item.time);
                dataArr.push(item.count);
              }
              this.setOrderEchart(timeArr, dataArr);
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单数据异常，请联系管理员',
                type: 'error'
              });
            });
          },
          setOrderEchart(timeArr, dataArr) {
            this.orderEchart.setOption({
              title: {
                text: '订单趋势',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              color: ["#00BFFF", "#FF00FF", "#1ce322", "#000000", '#EE7942'],
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeArr
              },
              yAxis: [{
                type: 'value',
                axisLabel: {
                  formatter: '{value}'
                }
              }],
              series: {
                name: '订单趋势',
                type: 'line',
                lineStyle: {
                  normal: {
                    width: 2,
                  }
                },
                data: dataArr
              }
            })
          },
   //获取订单趋势
          getOrderGongChuangEchart() {
            this.$axios.get(config.api_url + '/order/gongchuang/echart/'+this.startTime+'/'+this.endTime
            ).then(response => {
              let data = response.data.msg,
                timeArr = [],
                dataArr = [];
              for(const item of data) {
                timeArr.push(item.time);
                dataArr.push(item.count);
              }
              this.setOrderGongChuangEchart(timeArr, dataArr);
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单数据异常，请联系管理员',
                type: 'error'
              });
            });
          },
		setOrderGongChuangEchart(timeArr, dataArr) {
            this.orderGongChuangEchart.setOption({
              title: {
                text: '共创订单',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              color: ["#00BFFF", "#FF00FF", "#1ce322", "#000000", '#EE7942'],
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeArr
              },
              yAxis: [{
                type: 'value',
                axisLabel: {
                  formatter: '{value}'
                }
              }],
              series: {
                name: '共创订单',
                type: 'line',
                lineStyle: {
                  normal: {
                    width: 2,
                  }
                },
                data: dataArr
              }
            })
          },
           //获取订单利润
          getProfitSumMonth() {
            this.$axios.get(config.api_url + '/order/profitmonth'
            ).then(response => {
              this.profitSumMonth = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单金额异常，请联系管理员',
                type: 'error'
              });
            });
          },
          //获取订单金额
          getOrderSum() {
            this.$axios.get(config.api_url + '/order/sum/'+this.time
            ).then(response => {
              this.orderSum = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单金额异常，请联系管理员',
                type: 'error'
              });
            });
          },
           //获取订单利润
          getOrderProfitSum() {
            this.$axios.get(config.api_url + '/order/profit/'+this.time
            ).then(response => {
              this.profitSum = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单金额异常，请联系管理员',
                type: 'error'
              });
            });
          },
              //获取订单数量
          getOrderMonthCount() {
            this.$axios.get(config.api_url + '/order/countmonth'
            ).then(response => {
              this.orderCountMonth = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单数量异常，请联系管理员',
                type: 'error'
              });
            });
          },
            //获取订单金额
          getOrderMonthSum() {
            this.$axios.get(config.api_url + '/order/summonth'
            ).then(response => {
              this.orderSumMonth = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单金额异常，请联系管理员',
                type: 'error'
              });
            });
          },
          //获取单号数量
          getDanhaoCount() {
            this.$axios.get(config.api_url + '/order/danhaocount'
            ).then(response => {
              this.danhaoCount = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取单号数量异常，请联系管理员',
                type: 'error'
              });
            });
          },
            //获取共创订单利润
          getProfitSumGongChuangMonth() {
            this.$axios.get(config.api_url + '/order/profitgongchuangmonth'
            ).then(response => {
              this.profitSumGongChuangMonth = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取共创订单金额异常，请联系管理员',
                type: 'error'
              });
            });
          },
            //获取共创订单金额
          getOrderSumGongChuangMonth() {
            this.$axios.get(config.api_url + '/order/sumgongchuanmonth'
            ).then(response => {
              this.orderSumGongChuangMonth = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取共创订单金额异常，请联系管理员',
                type: 'error'
              });
            });
          },
             getuserZongCount() {
            this.$axios.get(config.api_url + '/order/userzongcount'
            ).then(response => {
              this.userZongCount = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取总分销异常，请联系管理员',
                type: 'error'
              });
            });
          },
          //获取订单金额趋势
          getOrderSumEchart() {
            this.$axios.get(config.api_url + '/order/sum/echart/'+this.startTime+'/'+this.endTime
            ).then(response => {
              let data = response.data.msg,
                timeArr = [],
                dataArr = [];
              for(const item of data) {
                timeArr.push(item.time);
                dataArr.push(item.sum);
              }
              this.setOrderSumEchart(timeArr, dataArr);
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单数据异常，请联系管理员',
                type: 'error'
              });
            });
          },
          setOrderSumEchart(timeArr, dataArr) {
            this.orderSumEchart.setOption({
              title: {
                text: '订单金额趋势',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              color: ["#FF00FF", "#1ce322", "#000000", '#EE7942'],
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeArr
              },
              yAxis: [{
                type: 'value',
                axisLabel: {
                  formatter: '{value}'
                }
              }],
              series: {
                name: '订单金额趋势',
                type: 'line',
                lineStyle: {
                  normal: {
                    width: 2,
                  }
                },
                data: dataArr
              }
            })
          },
 //获取订单金额趋势
          getOrderGongChuangSumEchart() {
            this.$axios.get(config.api_url + '/order/gongchuangsum/echart/'+this.startTime+'/'+this.endTime
            ).then(response => {
              let data = response.data.msg,
                timeArr = [],
                dataArr = [];
              for(const item of data) {
                timeArr.push(item.time);
                dataArr.push(item.sum);
              }
              this.setOrderGongChuangSumEchart(timeArr, dataArr);
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取订单数据异常，请联系管理员',
                type: 'error'
              });
            });
          },
        setOrderGongChuangSumEchart(timeArr, dataArr) {
            this.orderGongChuangSumEchart.setOption({
              title: {
                text: '共创订单金额',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
			color: ["#FF00FF", "#1ce322", "#000000", '#EE7942'],
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeArr
              },
              yAxis: [{
                type: 'value',
                axisLabel: {
                  formatter: '{value}'
                }
              }],
              series: {
                name: '共创订单金额',
                type: 'line',
                lineStyle: {
                  normal: {
                    width: 2,
                  }
                },
                data: dataArr
              }
            })
          },
          
          
          //获取用户数量
          getUserCount() {
            this.$axios.get(config.api_url + '/userinfo/count/'+this.time
            ).then(response => {
              this.userCount = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取用户数量异常，请联系管理员',
                type: 'error'
              });
            });
          },
          //获取库存告急
          getkuncunCount() {
            this.$axios.get(config.api_url + '/product/kucun'
            ).then(response => {
              this.kucunCount = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取用户数量异常，请联系管理员',
                type: 'error'
              });
            });
          },
            getProCount() {
            this.$axios.get(config.api_url + '/order/procount'
            ).then(response => {
              this.proCount = response.data.count;
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取总商品异常，请联系管理员',
                type: 'error'
              });
            });
          },
          //获取订单趋势
          getUserEchart() {
            this.$axios.get(config.api_url + '/userinfo/echart/'+this.startTime+'/'+this.endTime
            ).then(response => {
              let data = response.data.msg,
                timeArr = [],
                dataArr = [];
              for(const item of data) {
                timeArr.push(item.time);
                dataArr.push(item.count);
              }
              this.setUserEchart(timeArr, dataArr);
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取用户数据异常，请联系管理员',
                type: 'error'
              });
            });
          },
          setUserEchart(timeArr, dataArr) {
            this.userEchart.setOption({
              title: {
                text: '新增用户趋势',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              color: ["#1ce322", "#000000", '#EE7942'],
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeArr
              },
              yAxis: [{
                type: 'value',
                axisLabel: {
                  formatter: '{value}'
                }
              }],
              series: {
                name: '新增用户趋势',
                type: 'line',
                lineStyle: {
                  normal: {
                    width: 2,
                  }
                },
                data: dataArr
              }
            })
          },
                  // 获取利润图表
          getOrderProfitEchart() {
            this.$axios.get(config.api_url + '/order/profit/echart/'+this.startTime+'/'+this.endTime
            ).then(response => {
              let data = response.data.msg,
                timeArr = [],
                dataArr = [];
              for(const item of data) {
                timeArr.push(item.time);
                dataArr.push(item.sum);
              }
              this.setOrderProfitEchart(timeArr, dataArr);
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取利润数据异常，请联系管理员',
                type: 'error'
              });
            });
          },
                    // 截取当前数据到小数点后两位
    numFilter(value) {
      const realVal = parseFloat(value).toFixed(1);
      return realVal;
    },
          setOrderProfitEchart(timeArr, dataArr) {
            this.orderProfitEchart.setOption({
              title: {
                text: '订单利润趋势',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              color: ['#EE7942'],
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeArr
              },
              yAxis: [{
                type: 'value',
                axisLabel: {
                  formatter: '{value}'
                }
              }],
              series: {
                name: '订单利润趋势',
                type: 'line',
                lineStyle: {
                  normal: {
                    width: 2,
                  }
                },
                data: dataArr
              }
            })
          },
        },
   
        // keypoint：执行方法
        // “将回调延迟到下次 DOM 更新循环之后执行。在修改数据之后立即使用它，然后等待 DOM 更新。”
        mounted() {
          this.time = formatDate(new Date(), "yyyy-MM-dd");
          var myDate = new Date();
          myDate.setDate(myDate.getDate() - 365)
          this.startTime = formatDate(myDate, "yyyy-MM-dd");
          this.endTime = formatDate(new Date(), "yyyy-MM-dd");
          //初始化图表
          this.orderEchart = echarts.init(document.getElementById('order'));
          this.orderSumEchart = echarts.init(document.getElementById('orderSum'));
          this.userEchart = echarts.init(document.getElementById('user'));
		  this.orderGongChuangEchart = echarts.init(document.getElementById('gongChuangOrder'));
          this.orderGongChuangSumEchart = echarts.init(document.getElementById('gongChuangOrderSum'));
         // this.loginEchart = echarts.init(document.getElementById('login'));
           this.orderProfitEchart = echarts.init(document.getElementById('profitSum'));

          this.getOrderCount();
          this.getOrderEchart();
	      this.getOrderGongChuangEchart();
          this.getOrderGongChuangSumEchart();

          this.getOrderSum();
          this.getOrderSumEchart();

          this.getOrderProfitEchart();
          this.getUserCount();
          this.getUserEchart();
          this.getkuncunCount();
          this.getDanhaoCount();

 
          this.getOrderProfitSum();
          this.getProfitSumMonth();

          this.getOrderMonthCount();
          this.getOrderMonthSum();


          this.getOrderSumGongChuangMonth();
          this.getProfitSumGongChuangMonth();
          this.getProCount();
          this.getuserZongCount();

          let that = this;
          this.$nextTick(function() {
            //图表兼容处理
            $(window).resize(function(){
              window.onresize = that.orderEchart.resize();
              window.onresize = that.orderSumEchart.resize();
              window.onresize = that.orderGongChuangEchart.resize();
			    window.onresize = that.orderGongChuangSumEchart.resize();
              window.onresize = that.userEchart.resize();
              //window.onresize = that.loginEchart.resize();
                 window.onresize = that.orderProfitEchart.resize();
            });
          })
        }
    }
</script>

<style scoped>
  .bg-purple {
    background: #01a4ef;
  }
  .grid-content {
    border-radius: 4px;
    height: 100px;
    box-shadow: 1px 3px 5px 0 rgba(115, 111, 111, 0.5);
    text-shadow: 2px 2px 5px #324157;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .grid-content > div {
    color: #fff;
    text-align: center;
    padding-top: 8%;
  }
  .grid-content > div > div:first-child {
    font-size: 20px;
  }
  .grid-content > div > div:last-child {
    font-size: 30px;
    line-height: 35px;
  }
  #order, #orderSum, #gongChuangOrder, #gongChuangOrderSum, #user, #profitSum {
    height: 300px;
  }
</style>


// WEBPACK FOOTER //
// Dashboard.vue?6a1d0cb6